import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import 'moment/locale/pt-br';
import { CardArrivalDetail } from 'src/app/data/models/dto/arrival/card-arrival-detail';
import { GatesMonitorDto } from 'src/app/data/models/dto/arrival/gates-monitor.dto';
import { ArrivalStatus } from 'src/app/data/models/enum/arrival/arrival-status.enum';

@Component({
  selector: 'app-card-arrival',
  templateUrl: './card-arrival.component.html',
  styleUrls: ['./card-arrival.component.scss'],
})
export class CardArrivalComponent implements OnInit {
  @Input() gatesMonitor?: GatesMonitorDto | undefined;

  @Output() clickToStatusDetail = new EventEmitter<CardArrivalDetail>();
  @Output() releaseChildByArrivalid = new EventEmitter<string>();

  cardArrivalDetail: CardArrivalDetail | undefined;
  releaseButton: string = 'card-arrival-child-arrive-button';

  constructor() {}
  ngOnInit(): void {}

  clickArrivalStatusDetail(event: any) {
    const path = event.path || (event.composedPath && event.composedPath())
    if (
      path[0].className !== 'mat-button-wrapper' &&
      path[0].innerText !== 'Liberar'
    ) {
      const detail: CardArrivalDetail = {
        idArrival: this.gatesMonitor?.idArrival!,
        dtArrival: this.gatesMonitor?.dtCreated,
        statusArrival: this.gatesMonitor?.status,
        isResponsable: this.gatesMonitor?.isResponsable,
        responsable: this.gatesMonitor?.responsable,
        authorized: this.gatesMonitor?.authorized,
        authorizedProfiles: this.gatesMonitor?.profile[0]!,
        history: this.gatesMonitor?.history,
        authorizationType: this.gatesMonitor?.authorizationType,
      };
      this.clickToStatusDetail.emit(detail);
    }
  }

  enableReleaseButton(): boolean {
    if (
      !this.gatesMonitor?.isResponsable ||
      this.gatesMonitor?.status === ArrivalStatus.ARRIVED
    ) {
      this.releaseButton = 'card-arrival-child-arrive-button';
      return false;
    } else {
      this.releaseButton = 'card-arrival-child-arrive-button disabled';
      return true;
    }
  }

  releaseChild(idArrival: string) {
    this.releaseChildByArrivalid.emit(idArrival);
  }

  get timeRemaining(){
    let remaining
    let now = Number(new Date())
    let dtCreated = Number(new Date(this.gatesMonitor?.dtCreated!))

    if (!this.gatesMonitor?.arrivalForecastSeconds) {
      remaining = "indisponível"
    } else {
      let arrivalForecastSeconds = Number(this.gatesMonitor?.arrivalForecastSeconds! * 1000)
      let time = Math.ceil(dtCreated + arrivalForecastSeconds - now)

      if (time && time > 0) {
        time = time - 1000;
        let minutes = Math.ceil(time/1000/60)
          minutes == 1
          ? remaining = `${minutes} minuto`
          : remaining = `${minutes} minutos`
      }
      if (time <= 0) {
          time = 0
          remaining = `${time} minutos`
        }
    }

    setTimeout("timeRemaining()", 60000);
    return remaining
  }
}
